import { SVG } from './SVG';
const IconSignUpScroll = (props) => {
  const { size } = props;
  let width;
  let height;
  switch (size) {
    case 'small':
      width = '27';
      height = '35';
      break;
    default:
      width = '34';
      height = '42';
  }

  return (
    <SVG width={width} height={height} viewBox="0 0 34 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.6378 17.353L32.1136 17.3794C32.5489 17.3777 32.9015 17.0194 32.903 16.5767V4.99394C32.903 2.6351 31.0063 0.718811 28.6815 0.718811C26.3568 0.718811 24.4542 2.63509 24.4543 4.99813C24.4543 6.0724 24.6378 17.3538 24.6378 17.3538L24.6378 17.353Z"
        fill="#FFBFC5"
      />
      <path
        d="M4.66359 0C3.2545 0 2.04026 0.359862 1.20155 1.19442C0.362825 2.02898 0.000199903 3.23857 0.000236278 4.64282C-0.000474676 16.8004 0.000689304 28.9634 0.000236278 41.1209C0.00110926 41.777 0.696423 42.1995 1.27844 41.8967L12.9103 35.8185L24.4773 41.8967C25.0609 42.2066 25.764 41.7816 25.7623 41.1209V18.0964H32.4729C32.9537 18.0946 33.3427 17.7057 33.3444 17.2249V4.64282C33.3444 2.08064 31.2507 0 28.6827 0H4.66359ZM4.66359 1.7498H25.06C24.415 2.54584 24.0125 3.54312 24.0125 4.64282C24.0124 16.3213 24.0125 27.9945 24.0125 39.6736L13.317 34.0549C13.064 33.9233 12.7635 33.9233 12.5105 34.0549L1.74323 39.6804C1.74354 28.0028 1.74254 16.3203 1.74323 4.64282C1.7432 3.53164 2.01001 2.8582 2.4353 2.43506C2.86055 2.0119 3.54469 1.7498 4.66359 1.7498ZM28.6827 1.7498C30.3162 1.7498 31.5945 3.02445 31.5945 4.64282V16.3465H25.7623V4.64282C25.7623 3.02445 27.0492 1.7498 28.6827 1.7498Z"
        fill="#E24352"
      />
    </SVG>
  );
};

export { IconSignUpScroll as default, IconSignUpScroll };
